/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuildingLocationRequestPost } from '../../models/building-location-request-post';
import { BuildingLocationResponse } from '../../models/building-location-response';

export interface BuildingsControllerFindBuilding$Params {
      body: BuildingLocationRequestPost
}

export function buildingsControllerFindBuilding(http: HttpClient, rootUrl: string, params: BuildingsControllerFindBuilding$Params, context?: HttpContext): Observable<StrictHttpResponse<BuildingLocationResponse>> {
  const rb = new RequestBuilder(rootUrl, buildingsControllerFindBuilding.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuildingLocationResponse>;
    })
  );
}

buildingsControllerFindBuilding.PATH = '/planning-projects/v1-develop/buildings/find';
